<input #fileUploadInput class="file-input form-control" type="file"
  [accept]="accept"
  [multiple]="multiple"/>
